import styled from 'styled-components'
import { colors } from "../../branding";

export const StyledError404 = styled.div`
    width: 100%;
    height: 100%;
    min-height: 200px;
    min-width: 200px;
    display: flex;
    background-color: ${colors.light};
    flex-direction: row;
    align-items: center;
    
    & > div {
        margin: 0 auto;
    }
`


export const StyledLoader = styled.div`
    width: 100%;
    height: 100%;
    min-height: 200px;
    min-width: 200px;
    display: flex;
    background-color: ${colors.light};
    flex-direction: row;
    align-items: center;
    
    & > div {
    margin: 0 auto;
    }
`

export const StyledPlaceholder = styled.div`
  display: block;
  width: 100%;
  min-width: 200px;
  height: 100%;
  min-height: 200px;
  background-color: ${colors.greyLight};
  opacity: .5;
`
